<template>
    <div>
        <div class="container">
            <CommonBreadcrumb class="my-3"/>
        </div>

        <section class="banner_block">
            <picture>
                <source media="(min-width: 768px)" width="1903" height="656" type="image/webp" srcset="~/assets/landing/jewelry/banner.webp">
                <source media="(min-width: 768px)" width="1903" height="656" type="image/jpeg" srcset="~/assets/landing/jewelry/banner.jpg">
            
                <source media="(max-width: 767px)" width="767" height="349" type="image/webp" srcset="~/assets/landing/jewelry/banner_mobile.webp">
                <source media="(max-width: 767px)" width="767" height="349" type="image/jpeg" srcset="~/assets/landing/jewelry/banner_mobile.jpg">
            
                <img alt="Inspired by the radiance in you!" width="1903" height="656" type="image/jpeg" src="~/assets/landing/jewelry/banner.jpg">
            </picture>
            
            <div class="banner_upper">
                <h1 class="mb-0 font-active">Fine {{ $t('jewelry') }}</h1>
                <!-- <p class="mb-0" v-if="$country.is_india">Ditch the Norm, Be Uniquely You!</p> -->
                <!-- <p class="mb-0" v-else>Stay Confident & Stylish All Year Long!</p> -->
                <p class="mb-0" >{{ $t('jewelry') }} For The Big Day And Everyday!</p>
                <NuxtLink class="anker radious_four" :to="localePath({ name:'shop-all' })">Shop Now</NuxtLink>
            </div>
            
        </section>
      
        <div class="container-md">
            <div class="extra_text">
                <p class="mb-0 text-center" v-if="$country.is_india">
                    Shop fine {{ $t('jewelry') }} ranging from stud earrings, pendants, and tennis bracelets that blend with your personality, giving you the look you desire. Our <NuxtLink class="view_all_cta" :to="localePath({ name:'shop-all' })"> lab diamond {{ $t('jewelry') }}</NuxtLink> is eco-friendly with the same sparkle as mined diamond {{ $t('jewelry') }} but is a far more sustainable alternative that is priced better, thus making it a budget-friendly option.
                </p>
                <p class="mb-0 text-center" v-else>
                    Shop fine {{ $t('jewelry') }} ranging from stud earrings, pendants, and tennis bracelets that blend with your personality, giving you a look you desire. Our lab diamond {{ $t('jewelry') }} is eco-friendly with the same sparkle as mined diamond jewelry but is a far more sustainable alternative that is priced better, thus making it a budget-friendly option.
                </p>
            </div>
        </div>

        <div class="container-lg">
            <LandingShopJewelry />
        </div>

        <div class="container-fluid my-4 py-4">
            <HomeDiamondDifference />
          </div>

        <div class="container">
            <div class="row beyond_block align-items-center">
                <div class="col-md-12 col-12">
                    <div class="beyond_text text-center">
                        <h2 class="mb-0 font-active">Beyond Fine {{ $t('jewelry') }}</h2>
                        <p class="mb-0" v-if="$country.is_india">
                            Be it a gift for your mother, friend, fiancé, or yourself, the search ends here! Our fine {{ $t('jewelry') }} collection is the celebration of a woman’s eternal spirit to break barriers and achieve success in all avenues of life. Our fine {{ $t('jewelry') }} is not just about looking good. It’s about looking great while wearing sustainable and ethical {{ $t('jewelry') }} pieces that elevate your personality beyond fashion.
                        </p>
                        <p class="mb-0" v-else>
                            Be it a gift for your mother, friend, fiancé, or yourself; the search ends here! Our fine {{ $t('jewelry') }} collection is the celebration of a woman’s eternal spirit to break barriers and achieve success in all avenues of life. Our fine {{ $t('jewelry') }} is not just about looking good. It’s about looking great while wearing sustainable and ethical {{ $t('jewelry') }} pieces that elevate your personality beyond fashion.
                        </p>
                    </div>
                </div>
            </div>

            <div class="row beyond_more_block">
                <div class="col-lg-3 col-md-6 mb-3 col-12"> 
                    <div class="beyond_more_text">
                        <div class="check_svg">
                            <SvgHeaderSvg class="" :type="'check'" /></div>
                        <h3 class="mb-0">Curated Designs Just For You</h3>
                        <p class="mb-0" v-if="$country.is_india">
                            A day lived is a day worthy of celebration, and we believe in bringing that out with our curated fine {{ $t('jewelry') }} designs. Find or {{ $t('customize') }} diamond {{ $t('jewelry') }} pieces ranging from modern to vintage classics, perfect for occasions, celebrations, and everyday wear.
                        </p>
                        <p class="mb-0" v-else>
                            A day lived is a day worthy of celebration, and we believe in bringing that out with our curated fine {{ $t('jewelry') }} designs. Find or {{ $t('customize') }} diamond {{ $t('jewelry') }} pieces ranging from modern to vintage classics, perfect for occasions, celebrations, and everyday wear.  
                        </p>
                        <!-- <p class="mb-0 for_mobile">
                            A day lived is a day worthy of celebration, and   
                            <span v-if="showMore === 1">we believe in bringing that out with our curated fine jewelry designs. Find or customize diamond jewelry pieces ranging from modern to vintage classics perfect for occasions, celebrations, and everyday wear.</span>
                            <strong v-if="showMore != 1" @click="showMore = 1">Read More</strong>
                        </p> -->
                    </div>
                </div>

                <div class="col-lg-3 col-md-6 mb-3 col-12"> 
                    <div class="beyond_more_text">
                        <div class="check_svg">
                            <SvgHeaderSvg class="" :type="'check'" /></div>
                        <h3 class="mb-0">Expert Craftsmanship & Quality</h3>
                        <p class="mb-0" v-if="$country.is_india">
                            Our fine {{ $t('jewelry') }} pieces are handcrafted by artisans who have mastered the art of making {{ $t('jewelry') }} with precision. Every piece that reaches your doorstep is masterfully handcrafted and undergoes three rounds of quality checks before coming to your hands.
                        </p>
                        <p class="mb-0" v-else>
                            Our fine {{ $t('jewelry') }} pieces are handcrafted by artisans who have mastered the art of making {{ $t('jewelry') }} with precision. Every piece that reaches your doorstep is masterfully handcrafted and undergoes three rounds of quality checks before coming to your hands. 
                        </p>
                        <!-- <p class="mb-0 for_mobile">
                            Our fine jewelry pieces are handcrafted by 
                            <span v-if="showMore === 2">
                                artisans who have mastered the art of making jewelry with precision. Every piece that reaches your doorstep is masterfully handcrafted and undergoes three rounds of quality checks before reaching your doorstep. 
                            </span>
                            <strong v-if="showMore != 2" @click="showMore = 2">Read More</strong>
                        </p> -->
                    </div>
                </div>
                
                <div class="col-lg-3 col-md-6 mb-3 col-12"> 
                    <div class="beyond_more_text">
                        <div class="check_svg">
                            <SvgHeaderSvg class="" :type="'check'" /></div>
                        <h3 class="mb-0">Eco Friendly & Sustainable</h3>
                        <p class="mb-0">
                            Being fashion forward means taking an ethical approach where sustainability is the key. Grown in state-of-the-art laboratories that leave a far smaller carbon footprint, every eco-friendly diamond you shop at Friendly Diamonds is a step towards a greener and sustainable future.
                        </p>
                        <!-- <p class="mb-0 for_mobile">
                            Being fashion forward means taking an 
                            <span v-if="showMore === 3">ethical approach where sustainability is key. Grown in state-of-the-art laboratories that leave a far smaller carbon footprint, every eco-friendly diamond you shop at Friendly Diamonds is a step towards a greener and sustainable future.</span>
                            <strong v-if="showMore != 3" @click="showMore = 3">Read More</strong>
                        </p> -->
                    </div>
                </div>

                <div class="col-lg-3 col-md-6 mb-3 col-12"> 
                    <div class="beyond_more_text">
                        <div class="check_svg">
                            <SvgHeaderSvg class="" :type="'check'" /></div>
                        <h3 class="mb-0">Affordable & Budget-friendly</h3>
                        <p class="mb-0" v-if="$country.is_india">
                            We believe that diamond {{ $t('jewelry') }}, especially the pieces you wear daily, should be affordable and pocket-friendly. Our lab grown diamond {{ $t('jewelry') }} is competitively priced to ensure you get your favourite pieces without having to burn through your savings.
                        </p>
                        <p class="mb-0" v-else>
                            We believe that diamond {{ $t('jewelry') }}, especially the pieces you wear daily, should be affordable and pocket-friendly. Our lab grown diamond {{ $t('jewelry') }} is competitively priced to ensure you get your favorite pieces without having to burn through your savings. 
                        </p>
                        <!-- <p class="mb-0 for_mobile">
                            We believe that diamond jewelry, especially 
                            <span v-if="showMore === 4">the pieces you wear daily, should be affordable and pocket-friendly. Our lab grown diamond jewelry is competitively priced to ensure you get your favorite pieces without having to burn through your savings.</span> 
                            <strong v-if="showMore != 4" @click="showMore = 4">Read More</strong>
                        </p> -->
                    </div>
                </div> 
            </div>
        </div>  
        
        <div class="container-fluid container_fluid">
            <LandingCyoAllBanner />
        </div>
        
        <div class="container-fluid container_fluid">
           <div class="row custom_block row_mod">
                <div class="col-lg-6 col-md-12 col-12 justify-content-center align-items-center px-0 radius_mod_left">
                    <div class="custom_text_box d-flex justify-content-center align-items-center">
                        <div class="custom_text">
                            <h3 class="font-active"> 
                               {{ $t('customize') }} Your {{ $t('jewelry') }}
                            </h3>
                            <p v-if="$country.is_india">Bring your dream {{ $t('jewelry') }} to life. Design and {{ $t('customize') }} {{ $t('jewelry') }} precisely as per your imagination with the help of our experts.</p>
                            <p v-else>Bring your dream {{ $t('jewelry') }} to life. Design and {{ $t('customize') }} {{ $t('jewelry') }} precisely as per your imagination <br> with the help of our experts.</p>
                            <NuxtLink href="/customized-jewelry" class="anker radious_four">{{ $t('customize') }} Your {{ $t('jewelry') }}</NuxtLink>
                        </div>
                    </div>
                </div>
      
                <div class="col-lg-6 col-md-12 col-12 px-0 radius_mod_right">
                    <picture>
                        <source type="image/webp" srcset="~/assets/landing/jewelry/customize.webp" width="895" height="400">
                        <img loading="lazy" alt="Customize Your Jewelry" width="895" height="400" src="~/assets/landing/jewelry/customize.jpg">
                    </picture>
                </div>
           </div> 
        </div>

        <!-- <div class="container">
            <div class="customer_created">
               
            </div>
        </div> -->
        <LandingBestSeller :type="'shop'" />
        <!-- <section class="shape_block">
            <div class="container">
            </div>
        </section> -->
        <HomeBlog :type="'shop'" />
        
        <div class="container my-4 py-4">
            <FaqDynamicFaq class="my-4 py-4"/>
        </div>

        <div class="container-lg" v-if="$country.trustpilot">
            <HomeTrustpilotReview />
        </div>
        
    </div>
</template>


<script setup>
    const localePath = useLocalePath()
    const { $country } = useNuxtApp()
    useFetchMeta( useNuxtApp(), useRuntimeConfig() );
</script>


<style scoped>
.radius_mod_left {
    border-radius: 8px 0 0 8px;
    overflow: hidden;
}
.radius_mod_right {
    border-radius: 0 8px 8px 0;
    overflow: hidden;
}
.row{
    margin-left: 0;
    margin-right: 0;
}
.container_fluid{
    padding: 2% 3%;
}
section.banner_block{
    position: relative;
} 
.banner_upper {
    position: absolute;
    top: 50%;
    left: 34%;
    transform: translate(-50%, -50%);
    width: 35%;
}
.banner_upper h1 {
    font-size: 48px;
    
}
.banner_upper span {
    font-size: 15px;
    display: block;
    font-weight: 600;
    
}
.banner_upper p {
    color: #6a6161;
    font-size: 18px;
    padding: 3% 0 5%;
    
}
 a.anker {
    display: inline-block;
    font-size: 13px;
    color: #000;
    text-transform: uppercase;
    font-weight: 600;
    border: 1px solid #000;
    padding: 12px 25px;
}
a.anker_light{
    color: #fff;
    border: 1px solid #fff;
}
/* ------------------ */
.extra_text{
    padding: 4% 0;
}
.extra_text p{
    color: #6a6161;
    font-size: 16px;
    text-align: center;
} 
.extra_text p a{
    text-decoration: underline;
}
/* ------------------- */
.check_svg {
    display: flex;
    align-items: center;
    justify-content: center;
    transform: scale(1.5);
    width: 100%;
}
.beyond_block{
    padding: 4% 0;
}

.beyond_text h2 {
    font-size: 32px;
    padding-bottom: 2%;
    text-transform: capitalize;
}
.beyond_text p {
    color: #6a6161;
}
.beyond_more_block{
    padding: 4% 0;
}
.beyond_more_text img{
    border-radius: 50%;
}
.beyond_more_text {
    text-align: center;
}
.beyond_more_text h3 {
    font-size: 18px;
    font-weight: 600;
    padding: 8% 0 6%;
}
.beyond_more_text p {
    color: #6a6161;
    font-size: 16px;
}
/* --------------- */
.custom_text_box{
    background: #f8f8f8;
    height: 100%;
}
.custom_text h3 {
    font-size: 32px;
    text-transform: capitalize;
}
.custom_text {
    padding: 5%;
}
.custom_text p {
    font-size: 16px;
    padding: 2% 0;
}
.shape_block{
    background: #faf9f7;
    padding: 3% 0;
}
@media(max-width: 1600px){
    .custom_text p br{
        display: none;
    }
}
@media(max-width: 1300px){
    .banner_upper h1{
        font-size: 32px;
    }
    .custom_text h3{
        font-size: 28px;
    }
}

@media (max-width: 1200px){
    .custom_text p{
        padding: 0;
    }
   
    .custom_text h3{
        font-size: 26px;
    }
    .custom_text {
        padding: 3%;
        /* text-align: center; */
    }
}
@media (max-width: 1100px){
    .banner_upper p{
        font-size: 16px;
    }
}
@media(max-width: 992px){
    .shape_block{
        padding: 3%;
    }
    .check_svg {
        transform: scale(1);
    }
   
    .banner_upper p br{
        display: none;
    }
    .banner_upper {
        width: 40%;
        left: 31%;
    }
    .banner_upper h1{
        font-size: 32px;
    }
    .banner_upper span{
        font-size: 14px;
        margin-top: 3%;
    }
    .banner_upper h1 br{
        display: none;
    }
    .banner_upper p{
        font-size: 14px;
        padding: 3% 0;
    }
    .beyond_text h2, .custom_text h3{
        font-size: 24px;
    }
    .custom_text h3 br{
        display: none;
    }
    .beyond_more_text h3,.beyond_more_text p{
        font-size: 16px;
    }
    a.anker {
        padding: 7px 14px;
        text-align: center;
    }
    .custom_text p{
        padding: 0;
    }
    .custom_text p br{
        display: none;   
    }
    .custom_text {
        padding: 4%;
        /* text-align: center; */
    }
    .beyond_text {
        padding-right: 0;
    }
    .radius_mod_left {
        border-radius: 8px 8px 0 0 ;
    }
    .radius_mod_right {
        border-radius: 0 0 8px 8px;
    }
}
@media(max-width: 767px){
    .custom_text{
        text-align: center;
    }
    .shape_block {
        padding: 5%;
    }
    
    .banner_upper {
        position: relative;
        top: 0;
        left: 0;
        transform: none;
        width: 100%;
        text-align: center;
        background: #E7D8D2;
        padding: 6% 6% 8% 6%;
        margin-top: -5px;
    }
    .banner_upper h1{
        font-size: 32px;
    }
    .banner_upper p, .banner_upper span {
        font-size: 16px;
    }
    .extra_text {
        padding: 10% 5%;
    }
    .extra_text p{
        font-size: 16px;
    }
    .row_mod{
        flex-direction: column-reverse;
    }
    .beyond_text {
        text-align: center;
        padding: 6% 0;
    }
    .beyond_more_text h3 {
        font-size: 16px;
        padding: 4% 0 3%;
    }
    .beyond_more_text {
        margin-bottom: 5%;
    }
    .custom_text {
        padding: 10% 5%;
        /* background: #f2e3da; */
    }
    a.anker{
        padding: 10px 20px;
        width: 100%;
    }
    .radius_mod_right {
        border-radius:  8px 8px 0 0;
    }
    .radius_mod_left {
        border-radius:  0 0  8px 8px;
    }

}
/* ---------------- */
.banner_upper {
    position: absolute;
    top: 50%;
    left: 70%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: max-content;
}
.banner_upper h1 {
    font-size: 70px;
    color: #b67913;
    text-transform: uppercase;
}
.banner_upper p {
    color: #000;
    font-size: 18px;
    padding: 2% 0 4% 0;
    text-transform: capitalize;
}
.banner_upper a {
    min-width: 270px;
    letter-spacing: 1px;
}
@media(max-width: 1300px){
    .banner_upper h1{
        font-size: 48px;
    }
    .banner_upper p{
        font-size: 16px;
    }
    .banner_upper a {
        min-width: 220px;
        padding: 9px;
    }
}
@media(max-width: 992px){
  
    .banner_upper h1{
        font-size: 26px;
    }
    .banner_upper h1 br{
        display: none;
    }
    .banner_upper p{
        font-size: 16px;
        padding: 4% 2% 8% 0;    
    }
}
@media(max-width: 767px){
    .banner_upper {
        width: 100%;
        top: 73%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .banner_upper h1{
        font-size: 30px;
    }
    .banner_upper p {
        font-size: 16px;
        padding: 4% 2% 6% 0;
    }
}
</style>
